// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__hiXLB {
  border-radius: 12px;
  background: var(--light-gray, #F3F5F7);
  display: flex;
  max-width: 286px;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.styles_prompt__TlGYp {
  color: var(--black, #313333);
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 254px;
}

@media screen and (min-width: 640px) {
  .styles_wrapper__hiXLB {
    max-width: 303px;
  }
}
@media screen and (min-width: 1024px) {
  .styles_wrapper__hiXLB {
    min-width: 386px;
  }
  .styles_prompt__TlGYp {
    min-width: 320px;
  }
}
@media screen and (min-width: 1440px) {
  .styles_wrapper__hiXLB {
    min-width: 629px;
  }
  .styles_prompt__TlGYp {
    min-width: 581px;
    font-size: 16px;
  }
}
@media screen and (min-width: 1920px) {
  .styles_wrapper__hiXLB {
    min-width: 869px;
  }
  .styles_prompt__TlGYp {
    min-width: 851px;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PromptExampleList/PromptExampleItem/styles.module.scss","webpack://./src/constants/fonts.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,sCAAA;EAEA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;EACE,4BAAA;EACA,kCChBQ;EDiBR,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE;IACE,gBAAA;EAFF;AACF;AAKA;EACE;IACE,gBAAA;EAHF;EAMA;IACE,gBAAA;EAJF;AACF;AAOA;EACE;IACE,gBAAA;EALF;EAQA;IACE,gBAAA;IACA,eAAA;EANF;AACF;AASA;EACE;IACE,gBAAA;EAPF;EAUA;IACE,gBAAA;IACA,eAAA;EARF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.wrapper {\n  border-radius: 12px;\n  background: var(--light-gray, #F3F5F7);\n\n  display: flex;\n  max-width: 286px;\n  padding: 12px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n.prompt {\n  color: var(--black, #313333);\n  font-family: $poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  max-width: 254px;\n}\n\n@media screen and (min-width: 640px) {\n  .wrapper {\n    max-width: 303px;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .wrapper {\n    min-width: 386px;\n  }\n\n  .prompt {\n    min-width: 320px;\n  }\n}\n\n@media screen and (min-width: 1440px) {\n  .wrapper {\n    min-width: 629px;\n  }\n\n  .prompt {\n    min-width: 581px;\n    font-size: 16px;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .wrapper {\n    min-width: 869px;\n  }\n\n  .prompt {\n    min-width: 851px;\n    font-size: 16px;\n  }\n}\n\n//\n//.wrapper {\n//  max-width: 869px;\n//  min-width: 320px;\n//  background-color: #F3F5F7;\n//  border-radius: 12px;\n//\n//  padding: 16px 12px;\n//}\n//\n//.prompt {\n//  font-family: $poppins;\n//  font-weight: 400;\n//  color: $black;\n//  font-size: 14px;\n//  text-align: start;\n//}\n//\n//@media screen and (max-width: 393px) {\n//  .prompt {\n//    font-size: 12px;\n//  }\n//}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__hiXLB`,
	"prompt": `styles_prompt__TlGYp`
};
export default ___CSS_LOADER_EXPORT___;
